import consts from "@/consts"
import i18n from "@/i18n";
import {getApiProps} from "@/lib/lib";

const changedField = 'changed__time';

export default {
    state: {
        accidents_index: [],
        accidents: [],
    },
    actions: {
        fetchAccidents({dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }

                dispatch('setLastCall', {name: 'fetchAccidents', args, time: Date.now() / 1000})

                let params = getApiProps('accidents', {withAddress: 1, ...args})
                delete params.unitId
                this.$api.accidents.getAll(args.unitId, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchAccidents', args, inprogress: false})
                    });
            })
        },
        // fetchLastAccidents({commit, dispatch, getters}, args) {
        //     return new Promise((resolve, reject) => {
        //         if (!getters.getApiToken) {
        //             return reject(false)
        //         }
        //
        //         dispatch('setLastCall', {name: 'fetchLastAccidents', args, time: Date.now() / 1000})
        //         dispatch('setLastCall', {name: 'fetchAccidentsChanged', args, time: Date.now() / 1000})
        //
        //         let params = getApiProps('accidents', {withAddress: 1, ...args})
        //         delete params.unitId;delete params.last;
        //         this.$api.accidents.getLast(args.unitId, args.last, params)
        //             .then((response) => {
        //                 if (response.status < 400 && !response.data?.error) {
        //                     commit('storeAccidents', response.data)
        //
        //                     //forEach
        //                     //dispatch('fetchVideoRequest', response?.data?.media_request_id)
        // 					   //.then((data) => {
        // 					   //	commit('storeVideoRequests', [data])
        // 					   //})
        //                     resolve(true)
        //                 } else {
        //                     reject(response)
        //                 }
        //             })
        //             .catch((error) => {
        //                 reject(error)
        //                 console.error(error);
        //             })
        //             .finally(() => {
        //                 dispatch('setLastCall', {name: 'fetchLastAccidents', args, inprogress: false})
        //                 dispatch('setLastCall', {name: 'fetchAccidentsChanged', args, inprogress: false})
        //             });
        //     })
        // },
        fetchAccidents4Date({commit, dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                args = {unitId: '', date: '', ...args}
                if (args.date == 'today' || !args.date) args.date = getters.getDateToday
                let isToday = (args.date == getters.getDateToday)
                if (!getters.getApiToken || !(args.date > '')) {//!args.unitId ||
                    return reject(false)
                }

                if (args.unitId > 0 && !args.force) {
                    let index = getters.getAccidentsIndex.find(i => (i.unitId == args.unitId && i.date == args.date))
                    if (index) {
                        return resolve(true)
                    }
                }

                dispatch('setLastCall', {name: 'fetchAccidents4Date', args, time: Date.now() / 1000})
                if (isToday) {
                    dispatch('setLastCall', {name: 'fetchLastAccidents', args, time: Date.now() / 1000})
                    dispatch('setLastCall', {name: 'fetchAccidentsChanged', args, time: Date.now() / 1000})
                }

                let params = getApiProps('accidents', {withAddress: 1, ...args})
                delete params.unitId;delete params.date;
                this.$api.accidents.get4Date(args.unitId, args.date, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeAccidents', response.data)
                            // commit('setAccidentsIndex', {...args, count: response.data.length})
                            // if (!args.unitId && response.data.length) {
                            //     response.data
                            //         .map(e => e.unit_id)
                            //         .filter(arrayFilter_OnlyUnique)
                            //         .forEach(unitId => {
                            //             commit('setAccidentsIndex', {...args, unitId, count: 1})
                            //         })
                            // }

                            //forEach
                            response.data.forEach(accident => {
                                dispatch('fetchVideoRequest', {id: accident?.media_request_id})
                                    .then((data) => {
                                        commit('storeVideoRequests', [data])
                                    })
                            })
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchAccidents4Date', args, inprogress: false})
                        if (isToday) {
                            dispatch('setLastCall', {name: 'fetchLastAccidents', args, inprogress: false})
                            dispatch('setLastCall', {name: 'fetchAccidentsChanged', args, inprogress: false})
                        }
                    });
            })
        },
        fetchAccidents4Period({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                let isToday = (args.date == getters.getDateToday)
                if (!getters.getApiToken || !args.from || !args.to) {//!args.unitId ||
                    return reject(false)
                }

                // if (args.unitId > 0 && !args.force) {
                //     let index = getters.getAccidentsIndex.find(i => (i.unitId == args.unitId && i.date == args.date))
                //     if (index) {
                //         return resolve(true)
                //     }
                // }

                dispatch('setLastCall', {name: 'fetchAccidents4Period', args, time: Date.now() / 1000})
                /* getters.getTimeToday+24h and args.from/to intersect*/
                if (isToday) {
                    dispatch('setLastCall', {name: 'fetchLastAccidents', args, time: Date.now() / 1000})
                    dispatch('setLastCall', {name: 'fetchAccidentsChanged', args, time: Date.now() / 1000})
                }

                let params = getApiProps('accidents', {withAddress: 1, ...args})
                delete params.unitId;delete params.from;delete params.to;
                this.$api.accidents.get4Period(args.unitId, args.from, args.to, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeAccidents', response.data)
                            // commit('setAccidentsIndex', {...args, count: response.data.length})
                            // if (!args.unitId && response.data.length) {
                            //     response.data
                            //         .map(e => e.unit_id)
                            //         .filter(arrayFilter_OnlyUnique)
                            //         .forEach(unitId => {
                            //             commit('setAccidentsIndex', {...args, unitId, count: 1})
                            //         })
                            // }

                            //forEach
                            response.data.forEach(accident => {
                                dispatch('fetchVideoRequest', {id: accident?.media_request_id})
                                    .then((data) => {
                                        commit('storeVideoRequests', [data])
                                    })
                            })
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchAccidents4Period', args, inprogress: false})
                        /* getters.getTimeToday+24h and args.from/to intersect*/
                        if (isToday) {
                            dispatch('setLastCall', {name: 'fetchLastAccidents', args, inprogress: false})
                            dispatch('setLastCall', {name: 'fetchAccidentsChanged', args, inprogress: false})
                        }
                    });
            })
        },
        fetchAccidentsChanged({dispatch, commit, getters}, args) {
            if (!getters.getApiToken) {
                return Promise.resolve(null)
            }

            dispatch('setLastCall', {name: 'fetchLastAccidents', args, time: Date.now() / 1000})
            dispatch('setLastCall', {name: 'fetchAccidentsChanged', args, time: Date.now() / 1000})

            args = {...consts.querySettings.filter, ...args}
            delete args.date
            return dispatch('fetchAccidents', args)
                .then((data) => {
                    commit('storeAccidents', data)
                })
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchLastAccidents', args, inprogress: false})
                    dispatch('setLastCall', {name: 'fetchAccidentsChanged', args, inprogress: false})
                });
        },
        fetchFavoritesAccidents({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }

                dispatch('setLastCall', {name: 'fetchFavoritesAccidents', args, time: Date.now() / 1000})

                dispatch('fetchAccidents', {filter: {favorites: true}})
                    .then((data) => {
                        commit('storeAccidents', data)
                        resolve(true)
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchFavoritesAccidents', args, inprogress: false})
                    });
            })
        },

        reloadAccidents({commit, dispatch}, args) {
            commit('clearAccidents')
            return dispatch('fetchAccidents4Date', {date: 'today', ...args})
        },

        createAccident({commit, getters}, accident) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }

                //const params = {expand: 'MediaRequest'} //getApiProps('accidents')
                this.$api.accidents.create(accident.unitId, accident) //, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeAccidents', [response.data])
                            //dispatch('fetchVideoRequest', response?.data?.media_request_id)
                            // .then((data) => {
                            // 	commit('storeVideoRequests', [data])
                            // })
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        accidentPush2Driver({getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !args.id || !args.unitId) {
                    return reject(false)
                }

                let params = {...args}//getApiProps('accidents', args)
                delete params.unitId;delete params.id;delete params.type;
                this.$api.accidents.push2Driver(args.unitId, args.id, args.type, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },

        //sayHello() {}
    },
    mutations: {
        setAccidentsIndex(state, params) {
            let i = state.accidents_index.findIndex(i => i.date == params.date && i.unitId == params.unitId)
            if (i < 0) {
                state.accidents_index.push(Object.freeze({...params}))
            } else {
                state.accidents_index[i] = Object.freeze({...state.accidents_index[i], ...params})
            }
        },
        storeAccidents(state, nAccidents) {
            if (!state.accidents.length) {
                state.accidents = nAccidents.map(r => Object.freeze(r))
                return true
            }

            nAccidents.forEach(function (nAccident) {
                let i = state.accidents.findIndex(r => (r.xid == nAccident.xid))
                if (i < 0) {
                    if (!nAccident.removed_at) state.accidents.push(Object.freeze(nAccident))
                } else
                if (state.accidents[i][changedField] != nAccident[changedField]) {
                    // updateObjectByDiff(state.accidents[i], nAccident)
                    if (nAccident?.removed_at) {
                        state.accidents.splice(i, 1)
                    } else {
                        delete nAccident.xid
                        state.accidents[i] = Object.freeze({...state.accidents[i], ...nAccident})
                    }
                }
            })
        },
        clearAccidents(state, {unitId} = {}) {
            if (unitId) {
                state.accidents = state.accidents.filter(a => (a.unit_id || a.object_id) != unitId)
                state.accidents_index = state.accidents_index.filter(i => i.unitId != unitId)
            } else {
                state.accidents = [];
                state.accidents_index = [];
            }
        },
    },
    getters: {
        getNewAccidentsCount(state, getters) {
            let lastVisit = getters.getLastVisitNotifications
            if (getters.getTimeToday > lastVisit) lastVisit = getters.getTimeToday
            return state.accidents.filter(e => e.time?.utc > lastVisit).length
        },
        getAccidentsIndex(state) {
            return state.accidents_index
        },
        getAccidents(state) {
            return state.accidents
        },
        getAccidentsI18nMessages(state) {
            return state.accidents
                .map((eventsTextByXid, event) => {
                    let message = event?.message?.msg;
                    if (message) {
                        let matches = message.matchAll(/\$t{([\w]+)}/gi);
                        Array.from(matches).forEach(match => {
                            let str = event?.message[match[1]] || ''
                            let translateKey = 'message.' + 'accident' + '.' + str
                            str = i18n.global.te(translateKey) ? i18n.global.t(translateKey) : str
                            message = message.replace(match[0], str);
                        })
                    }
                    return {type: event.type, xid: event.xid, message};
                })
        },
        getAccidentsI18nMessagesById(state) {
            return state.accidents
                .reduce((eventsTextByXid, event) => {
                    let message = event?.message?.msg;
                    if (message) {
                        let matches = message.matchAll(/\$t{([\w]+)}/gi);
                        Array.from(matches).forEach(match => {
                            let str = event?.message[match[1]] || ''
                            let translateKey = 'message.' + 'accident' + '.' + str
                            str = i18n.global.te(translateKey) ? i18n.global.t(translateKey) : str
                            message = message.replace(match[0], str);
                        })
                    }
                    eventsTextByXid[event.xid] = message;// || i18n.global.t('message.Unknown')//???
                    return eventsTextByXid;
                }, {})
        },
        getAccidentsByIds(state) {
            return state.accidents.reduce((out, request) => {
                out[request.id] = request
                return out
            }, {})
        },
    }
}
